// import React, { useState, useMemo, useCallback, useEffect } from "react";
// import {
//   Button,
//   Card,
//   Col,
//   Container,
//   Form,
//   Modal,
//   Row,
// } from "react-bootstrap";
// import Breadcrumb from "Common/BreadCrumb";
// import CountUp from "react-countup";
// import TableContainer from "Common/TableContainer";
// import { userList } from "Common/data";
// import Flatpickr from "react-flatpickr";
// import dummyImg from "../../assets/images/users/user-dummy-img.jpg";
// import { Link } from "react-router-dom";
// import { fetchUsers } from "api/apis";

// const UsersList = () => {
//   document.title = "Users List | Toner eCommerce + Admin React Template";
//   const [modal_AddUserModals, setmodal_AddUserModals] =
//     useState<boolean>(false);
//   const [isMultiDeleteButton, setIsMultiDeleteButton] =
//     useState<boolean>(false);
//   const [usersData, setUsersData] = useState<any[]>([]);
//   const [loading, setLoading] = useState<boolean>(true);
//   const [pagination, setPagination] = useState({
//     page: 1,
//     limit: 10,
//     total: 0,
//   });

//   const getUsers = useCallback(async (page: number, limit: number) => {
//     try {
//       setLoading(true);
//       const response = await fetchUsers(page, limit);
//       setUsersData(response?.users);
//       setPagination({
//         page: response.page,
//         limit: response.limit,
//         total: response.total,
//       });
//     } catch (error) {
//       console.error("Error fetching users:", error);
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   // Load initial data
//   useEffect(() => {
//     getUsers(pagination.page, pagination.limit);
//   }, [getUsers, pagination.page, pagination.limit]);

//   // Handle page change
//   const handlePageChange = (page: number) => {
//     setPagination((prev) => ({ ...prev, page }));
//   };

//   function tog_AddUserModals() {
//     setmodal_AddUserModals(!modal_AddUserModals);
//   }

//   // Checked All
//   const checkedAll = useCallback(() => {
//     const checkall = document.getElementById("checkAll") as HTMLInputElement;
//     const ele = document.querySelectorAll(".userCheckBox");

//     if (checkall.checked) {
//       ele.forEach((ele: any) => {
//         ele.checked = true;
//       });
//     } else {
//       ele.forEach((ele: any) => {
//         ele.checked = false;
//       });
//     }
//     checkedbox();
//   }, []);

//   const checkedbox = () => {
//     const ele = document.querySelectorAll(".userCheckBox:checked");
//     ele.length > 0
//       ? setIsMultiDeleteButton(true)
//       : setIsMultiDeleteButton(false);
//   };

//   const columns = useMemo(
//     () => [
//       {
//         Header: (
//           <div className="form-check">
//             <input
//               className="form-check-input"
//               type="checkbox"
//               id="checkAll"
//               onClick={() => checkedAll()}
//             />
//           </div>
//         ),
//         Cell: (cellProps: any) => {
//           return (
//             <div className="form-check">
//               <input
//                 className="userCheckBox form-check-input"
//                 type="checkbox"
//                 name="chk_child"
//                 value={cellProps.row.original._id}
//                 onChange={() => checkedbox()}
//               />
//             </div>
//           );
//         },
//         id: "#",
//       },
//       {
//         Header: "User Name",
//         disableFilters: true,
//         filterable: true,
//         accessor: (cellProps: any) => {
//           return (
//             <div className="d-flex align-items-center gap-2">
//               <div className="flex-shrink-0">
//                 <img
//                   src={cellProps.user_img}
//                   alt=""
//                   className="avatar-xs rounded-circle user-profile-img"
//                 />
//               </div>
//               <div className="flex-grow-1 ms-2 user_name">
//                 {cellProps.firstName}
//               </div>
//             </div>
//           );
//         },
//       },
//       {
//         Header: "Email",
//         accessor: "email",
//         disableFilters: true,
//         filterable: true,
//       },
//       {
//         Header: "Create Date",
//         accessor: "createdAt", // Changed from date to createdAt (MongoDB default)
//         disableFilters: true,
//         filterable: true,
//         Cell: (cellProps: any) => {
//           return new Date(cellProps.value).toLocaleDateString(); // Format date
//         },
//       },
//       {
//         Header: "Account Status",
//         disableFilters: true,
//         filterable: true,
//         accessor: (cellProps: any) => {
//           switch (cellProps.status) {
//             case "Active":
//               return (
//                 <span className="badge bg-success-subtle text-success">
//                   {" "}
//                   {cellProps.status}
//                 </span>
//               );
//             case "Inactive":
//               return (
//                 <span className="badge bg-danger-subtle text-danger">
//                   {" "}
//                   {cellProps.status}
//                 </span>
//               );
//             default:
//               return (
//                 <span className="badge bg-success-subtle text-success">
//                   {" "}
//                   {cellProps.status}
//                 </span>
//               );
//           }
//         },
//       },
//       {
//         Header: "Action",
//         disableFilters: true,
//         filterable: true,
//         accessor: (cellProps: any) => {
//           return (
//             <div className="d-flex gap-2">
//               <div className="edit">
//                 <Button
//                   variant="ghost-info"
//                   size="sm"
//                   className="btn-ghost-info btn-icon edit-item-btn"
//                 >
//                   <i className="ph-pencil-line"></i>
//                 </Button>
//               </div>
//               <div className="remove">
//                 <Button
//                   variant="ghost-danger"
//                   size="sm"
//                   className="btn-ghost-danger btn-icon remove-item-btn"
//                 >
//                   <i className="ph-trash"></i>
//                 </Button>
//               </div>
//             </div>
//           );
//         },
//       },
//     ],
//     [checkedAll]
//   );

//   return (
//     <React.Fragment>
//       <div className="page-content">
//         <Container fluid={true}>
//           <Breadcrumb title="Users List" pageTitle="More" />

//           <Row>
//             <Col xxl={3} md={6}>
//               <Card className="card-height-100 bg-warning-subtle border-0 overflow-hidden">
//                 <div className="position-absolute end-0 start-0 top-0 z-0">
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     version="1.1"
//                     // xmlns:xlink="http://www.w3.org/1999/xlink"
//                     width="400"
//                     height="250"
//                     preserveAspectRatio="none"
//                     viewBox="0 0 400 250"
//                   >
//                     <g mask='url("#SvgjsMask1530")' fill="none">
//                       <path
//                         d="M209 112L130 191"
//                         strokeWidth="10"
//                         stroke="url(#SvgjsLinearGradient1531)"
//                         strokeLinecap="round"
//                         className="BottomLeft"
//                       ></path>
//                       <path
//                         d="M324 10L149 185"
//                         strokeWidth="8"
//                         stroke="url(#SvgjsLinearGradient1532)"
//                         strokeLinecap="round"
//                         className="TopRight"
//                       ></path>
//                       <path
//                         d="M333 35L508 -140"
//                         strokeWidth="10"
//                         stroke="url(#SvgjsLinearGradient1532)"
//                         strokeLinecap="round"
//                         className="TopRight"
//                       ></path>
//                       <path
//                         d="M282 58L131 209"
//                         strokeWidth="10"
//                         stroke="url(#SvgjsLinearGradient1531)"
//                         strokeLinecap="round"
//                         className="BottomLeft"
//                       ></path>
//                       <path
//                         d="M290 16L410 -104"
//                         strokeWidth="6"
//                         stroke="url(#SvgjsLinearGradient1532)"
//                         strokeLinecap="round"
//                         className="TopRight"
//                       ></path>
//                       <path
//                         d="M216 186L328 74"
//                         strokeWidth="6"
//                         stroke="url(#SvgjsLinearGradient1531)"
//                         strokeLinecap="round"
//                         className="BottomLeft"
//                       ></path>
//                       <path
//                         d="M255 53L176 132"
//                         strokeWidth="10"
//                         stroke="url(#SvgjsLinearGradient1531)"
//                         strokeLinecap="round"
//                         className="BottomLeft"
//                       ></path>
//                       <path
//                         d="M339 191L519 11"
//                         strokeWidth="8"
//                         stroke="url(#SvgjsLinearGradient1531)"
//                         strokeLinecap="round"
//                         className="BottomLeft"
//                       ></path>
//                       <path
//                         d="M95 151L185 61"
//                         strokeWidth="6"
//                         stroke="url(#SvgjsLinearGradient1532)"
//                         strokeLinecap="round"
//                         className="TopRight"
//                       ></path>
//                       <path
//                         d="M249 16L342 -77"
//                         strokeWidth="6"
//                         stroke="url(#SvgjsLinearGradient1532)"
//                         strokeLinecap="round"
//                         className="TopRight"
//                       ></path>
//                       <path
//                         d="M129 230L286 73"
//                         strokeWidth="10"
//                         stroke="url(#SvgjsLinearGradient1531)"
//                         strokeLinecap="round"
//                         className="BottomLeft"
//                       ></path>
//                       <path
//                         d="M80 216L3 293"
//                         strokeWidth="6"
//                         stroke="url(#SvgjsLinearGradient1531)"
//                         strokeLinecap="round"
//                         className="BottomLeft"
//                       ></path>
//                     </g>
//                     <defs>
//                       <mask id="SvgjsMask1530">
//                         <rect width="400" height="250" fill="#ffffff"></rect>
//                       </mask>
//                       <linearGradient
//                         x1="100%"
//                         y1="0%"
//                         x2="0%"
//                         y2="100%"
//                         id="SvgjsLinearGradient1531"
//                       >
//                         <stop
//                           stopColor="rgba(var(--tb-warning-rgb), 0)"
//                           offset="0"
//                         ></stop>
//                         <stop
//                           stopColor="rgba(var(--tb-warning-rgb), 0.2)"
//                           offset="1"
//                         ></stop>
//                       </linearGradient>
//                       <linearGradient
//                         x1="0%"
//                         y1="100%"
//                         x2="100%"
//                         y2="0%"
//                         id="SvgjsLinearGradient1532"
//                       >
//                         <stop
//                           stopColor="rgba(var(--tb-warning-rgb), 0)"
//                           offset="0"
//                         ></stop>
//                         <stop
//                           stopColor="rgba(var(--tb-warning-rgb), 0.2)"
//                           offset="1"
//                         ></stop>
//                       </linearGradient>
//                     </defs>
//                   </svg>
//                 </div>
//                 <Card.Body className="p-4 z-1 position-relative">
//                   <h4 className="fs-22 fw-semibold mb-3">
//                     <CountUp end={7845102} separator="," />{" "}
//                   </h4>
//                   <p className="mb-0 fw-medium text-uppercase fs-14">
//                     Total Users
//                   </p>
//                 </Card.Body>
//               </Card>
//             </Col>
//             <Col xxl={3} md={6}>
//               <Card className="card-height-100 bg-success-subtle border-0 overflow-hidden">
//                 <div className="position-absolute end-0 start-0 top-0 z-0">
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     version="1.1"
//                     // xmlns:xlink="http://www.w3.org/1999/xlink"
//                     width="400"
//                     height="250"
//                     preserveAspectRatio="none"
//                     viewBox="0 0 400 250"
//                   >
//                     <g mask='url("#SvgjsMask1608")' fill="none">
//                       <path
//                         d="M390 87L269 208"
//                         strokeWidth="10"
//                         stroke="url(#SvgjsLinearGradient1609)"
//                         strokeLinecap="round"
//                         className="TopRight"
//                       ></path>
//                       <path
//                         d="M358 175L273 260"
//                         strokeWidth="8"
//                         stroke="url(#SvgjsLinearGradient1610)"
//                         strokeLinecap="round"
//                         className="BottomLeft"
//                       ></path>
//                       <path
//                         d="M319 84L189 214"
//                         strokeWidth="10"
//                         stroke="url(#SvgjsLinearGradient1609)"
//                         strokeLinecap="round"
//                         className="TopRight"
//                       ></path>
//                       <path
//                         d="M327 218L216 329"
//                         strokeWidth="8"
//                         stroke="url(#SvgjsLinearGradient1610)"
//                         strokeLinecap="round"
//                         className="BottomLeft"
//                       ></path>
//                       <path
//                         d="M126 188L8 306"
//                         strokeWidth="8"
//                         stroke="url(#SvgjsLinearGradient1610)"
//                         strokeLinecap="round"
//                         className="BottomLeft"
//                       ></path>
//                       <path
//                         d="M220 241L155 306"
//                         strokeWidth="10"
//                         stroke="url(#SvgjsLinearGradient1610)"
//                         strokeLinecap="round"
//                         className="BottomLeft"
//                       ></path>
//                       <path
//                         d="M361 92L427 26"
//                         strokeWidth="6"
//                         stroke="url(#SvgjsLinearGradient1609)"
//                         strokeLinecap="round"
//                         className="TopRight"
//                       ></path>
//                       <path
//                         d="M391 188L275 304"
//                         strokeWidth="8"
//                         stroke="url(#SvgjsLinearGradient1609)"
//                         strokeLinecap="round"
//                         className="TopRight"
//                       ></path>
//                       <path
//                         d="M178 74L248 4"
//                         strokeWidth="10"
//                         stroke="url(#SvgjsLinearGradient1610)"
//                         strokeLinecap="round"
//                         className="BottomLeft"
//                       ></path>
//                       <path
//                         d="M84 52L-56 192"
//                         strokeWidth="6"
//                         stroke="url(#SvgjsLinearGradient1610)"
//                         strokeLinecap="round"
//                         className="BottomLeft"
//                       ></path>
//                       <path
//                         d="M183 111L247 47"
//                         strokeWidth="10"
//                         stroke="url(#SvgjsLinearGradient1610)"
//                         strokeLinecap="round"
//                         className="BottomLeft"
//                       ></path>
//                       <path
//                         d="M46 8L209 -155"
//                         strokeWidth="6"
//                         stroke="url(#SvgjsLinearGradient1609)"
//                         strokeLinecap="round"
//                         className="TopRight"
//                       ></path>
//                     </g>
//                     <defs>
//                       <mask id="SvgjsMask1608">
//                         <rect width="400" height="250" fill="#ffffff"></rect>
//                       </mask>
//                       <linearGradient
//                         x1="0%"
//                         y1="100%"
//                         x2="100%"
//                         y2="0%"
//                         id="SvgjsLinearGradient1609"
//                       >
//                         <stop
//                           stopColor="rgba(var(--tb-success-rgb), 0)"
//                           offset="0"
//                         ></stop>
//                         <stop
//                           stopColor="rgba(var(--tb-success-rgb), 0.2)"
//                           offset="1"
//                         ></stop>
//                       </linearGradient>
//                       <linearGradient
//                         x1="100%"
//                         y1="0%"
//                         x2="0%"
//                         y2="100%"
//                         id="SvgjsLinearGradient1610"
//                       >
//                         <stop
//                           stopColor="rgba(var(--tb-success-rgb), 0)"
//                           offset="0"
//                         ></stop>
//                         <stop
//                           stopColor="rgba(var(--tb-success-rgb), 0.2)"
//                           offset="1"
//                         ></stop>
//                       </linearGradient>
//                     </defs>
//                   </svg>
//                 </div>
//                 <Card.Body className="p-4 z-1 position-relative">
//                   <h4 className="fs-22 fw-semibold mb-3">
//                     <CountUp end={559.25} decimals={2} suffix="k" />
//                   </h4>
//                   <p className="mb-0 fw-medium text-uppercase fs-14">
//                     Active Users
//                   </p>
//                 </Card.Body>
//               </Card>
//             </Col>
//             <Col xxl={3} md={6}>
//               <Card className="card-height-100 bg-info-subtle border-0 overflow-hidden">
//                 <div className="position-absolute end-0 start-0 top-0 z-0">
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     version="1.1"
//                     // xmlns:xlink="http://www.w3.org/1999/xlink"
//                     width="400"
//                     height="250"
//                     preserveAspectRatio="none"
//                     viewBox="0 0 400 250"
//                   >
//                     <g mask='url("#SvgjsMask1551")' fill="none">
//                       <path
//                         d="M306 65L446 -75"
//                         strokeWidth="8"
//                         stroke="url(#SvgjsLinearGradient1552)"
//                         strokeLinecap="round"
//                         className="BottomLeft"
//                       ></path>
//                       <path
//                         d="M399 2L315 86"
//                         strokeWidth="10"
//                         stroke="url(#SvgjsLinearGradient1553)"
//                         strokeLinecap="round"
//                         className="TopRight"
//                       ></path>
//                       <path
//                         d="M83 77L256 -96"
//                         strokeWidth="6"
//                         stroke="url(#SvgjsLinearGradient1553)"
//                         strokeLinecap="round"
//                         className="TopRight"
//                       ></path>
//                       <path
//                         d="M281 212L460 33"
//                         strokeWidth="6"
//                         stroke="url(#SvgjsLinearGradient1553)"
//                         strokeLinecap="round"
//                         className="TopRight"
//                       ></path>
//                       <path
//                         d="M257 62L76 243"
//                         strokeWidth="6"
//                         stroke="url(#SvgjsLinearGradient1553)"
//                         strokeLinecap="round"
//                         className="TopRight"
//                       ></path>
//                       <path
//                         d="M305 123L214 214"
//                         strokeWidth="6"
//                         stroke="url(#SvgjsLinearGradient1552)"
//                         strokeLinecap="round"
//                         className="BottomLeft"
//                       ></path>
//                       <path
//                         d="M327 222L440 109"
//                         strokeWidth="6"
//                         stroke="url(#SvgjsLinearGradient1552)"
//                         strokeLinecap="round"
//                         className="BottomLeft"
//                       ></path>
//                       <path
//                         d="M287 109L362 34"
//                         strokeWidth="10"
//                         stroke="url(#SvgjsLinearGradient1553)"
//                         strokeLinecap="round"
//                         className="TopRight"
//                       ></path>
//                       <path
//                         d="M259 194L332 121"
//                         strokeWidth="8"
//                         stroke="url(#SvgjsLinearGradient1553)"
//                         strokeLinecap="round"
//                         className="TopRight"
//                       ></path>
//                       <path
//                         d="M376 186L240 322"
//                         strokeWidth="8"
//                         stroke="url(#SvgjsLinearGradient1553)"
//                         strokeLinecap="round"
//                         className="TopRight"
//                       ></path>
//                       <path
//                         d="M308 153L123 338"
//                         strokeWidth="6"
//                         stroke="url(#SvgjsLinearGradient1553)"
//                         strokeLinecap="round"
//                         className="TopRight"
//                       ></path>
//                       <path
//                         d="M218 62L285 -5"
//                         strokeWidth="8"
//                         stroke="url(#SvgjsLinearGradient1552)"
//                         strokeLinecap="round"
//                         className="BottomLeft"
//                       ></path>
//                     </g>
//                     <defs>
//                       <mask id="SvgjsMask1551">
//                         <rect width="400" height="250" fill="#ffffff"></rect>
//                       </mask>
//                       <linearGradient
//                         x1="100%"
//                         y1="0%"
//                         x2="0%"
//                         y2="100%"
//                         id="SvgjsLinearGradient1552"
//                       >
//                         <stop
//                           stopColor="rgba(var(--tb-info-rgb), 0)"
//                           offset="0"
//                         ></stop>
//                         <stop
//                           stopColor="rgba(var(--tb-info-rgb), 0.2)"
//                           offset="1"
//                         ></stop>
//                       </linearGradient>
//                       <linearGradient
//                         x1="0%"
//                         y1="100%"
//                         x2="100%"
//                         y2="0%"
//                         id="SvgjsLinearGradient1553"
//                       >
//                         <stop
//                           stopColor="rgba(var(--tb-info-rgb), 0)"
//                           offset="0"
//                         ></stop>
//                         <stop
//                           stopColor="rgba(var(--tb-info-rgb), 0.2)"
//                           offset="1"
//                         ></stop>
//                       </linearGradient>
//                     </defs>
//                   </svg>
//                 </div>
//                 <Card.Body className="p-4 z-1 position-relative">
//                   <h4 className="fs-22 fw-semibold mb-3">
//                     <CountUp end={559.25} decimals={2} suffix="k" />
//                   </h4>
//                   <p className="mb-0 fw-medium text-uppercase fs-14">
//                     Unactive Users
//                   </p>
//                 </Card.Body>
//               </Card>
//             </Col>
//             <Col xxl={3} md={6}>
//               <Card className="bg-light border-0">
//                 <Card.Body className="p-3">
//                   <div className="p-3 bg-white rounded">
//                     <div className="d-flex align-items-center gap-3">
//                       <div className="flex-shrink-0">
//                         <div className="avatar-sm">
//                           <div className="avatar-title bg-danger-subtle text-danger fs-4 rounded">
//                             <i className="ph-gift"></i>
//                           </div>
//                         </div>
//                       </div>
//                       <div className="flex-grow-1">
//                         <Link to="#" className="stretched-link">
//                           <h6 className="fs-17">
//                             Invite your friends to Anjalgold
//                           </h6>
//                         </Link>
//                         <p className="text-muted mb-0">
//                           Nor again is there anyone pursues
//                         </p>
//                       </div>
//                     </div>
//                   </div>
//                 </Card.Body>
//               </Card>
//             </Col>
//           </Row>

//           <Row id="usersList">
//             <Col lg={12}>
//               <Card>
//                 <Card.Body>
//                   <Row className="g-lg-2 g-4">
//                     <Col lg={3}>
//                       <div className="search-box">
//                         <input
//                           type="text"
//                           className="form-control search"
//                           placeholder="Search for users..."
//                         />
//                         <i className="ri-search-line search-icon"></i>
//                       </div>
//                     </Col>

//                     {isMultiDeleteButton && (
//                       <Button variant="danger" className="btn-icon">
//                         <i className="ri-delete-bin-2-line"></i>
//                       </Button>
//                     )}

//                     <Col sm={3} className="col-lg-auto ms-auto">
//                       <Button
//                         onClick={() => tog_AddUserModals()}
//                         variant="primary"
//                         type="button"
//                         className="w-100 add-btn"
//                       >
//                         Add User
//                       </Button>
//                     </Col>
//                     <Col sm={9} className="col-lg-auto">
//                       <select
//                         className="form-select"
//                         data-choices
//                         data-choices-search-false
//                         name="choices-single-default"
//                         id="idStatus"
//                       >
//                         <option value="all">All</option>
//                         <option value="Today">Today</option>
//                         <option value="Yesterday">Yesterday</option>
//                         <option value="Last 7 Days">Last 7 Days</option>
//                         <option value="Last 30 Days">Last 30 Days</option>
//                         <option defaultValue="This Month">This Month</option>
//                         <option value="Last Month">Last Month</option>
//                       </select>
//                     </Col>
//                   </Row>
//                 </Card.Body>
//               </Card>
//               {/* <Card>
//                 <Card.Body className="p-0">
//                   <TableContainer
//                     columns={columns || []}
//                     data={userList || []}
//                     // isGlobalFilter={false}
//                     iscustomPageSize={false}
//                     isBordered={false}
//                     customPageSize={10}
//                     className="custom-header-css table align-middle table-nowrap"
//                     tableClass="table-centered align-middle table-nowrap mb-0"
//                     theadClass="text-muted table-light"
//                     SearchPlaceholder="Search Products..."
//                   />
//                   <div className="noresult" style={{ display: "none" }}>
//                     <div className="text-center">
//                       <h5 className="mt-2">Sorry! No Result Found</h5>
//                       <p className="text-muted mb-0">
//                         We've searched more than 150+ Orders We did not find any
//                         orders for you search.
//                       </p>
//                     </div>
//                   </div>
//                 </Card.Body>
//               </Card> */}
//               <Card>
//                 <Card.Body className="p-0">
//                   {loading ? (
//                     <div className="text-center p-5">
//                       <div
//                         className="spinner-border text-primary"
//                         role="status"
//                       >
//                         <span className="visually-hidden">Loading...</span>
//                       </div>
//                     </div>
//                   ) : (
//                     <>
//                       <TableContainer
//                         columns={columns || []}
//                         data={usersData || []}
//                         iscustomPageSize={false}
//                         isBordered={false}
//                         customPageSize={pagination.limit}
//                         className="custom-header-css table align-middle table-nowrap"
//                         tableClass="table-centered align-middle table-nowrap mb-0"
//                         theadClass="text-muted table-light"
//                         SearchPlaceholder="Search Users..."
//                         pagination={pagination}
//                         handlePageChange={handlePageChange}
//                       />
//                       {usersData.length === 0 && (
//                         <div className="noresult">
//                           <div className="text-center">
//                             <h5 className="mt-2">No Users Found</h5>
//                             <p className="text-muted mb-0">
//                               There are no users to display at the moment.
//                             </p>
//                           </div>
//                         </div>
//                       )}
//                     </>
//                   )}
//                 </Card.Body>
//               </Card>
//             </Col>
//           </Row>

//           <Modal
//             className="fade"
//             show={modal_AddUserModals}
//             onHide={() => {
//               tog_AddUserModals();
//             }}
//             centered
//           >
//             <Modal.Header className="px-4 pt-4" closeButton>
//               <h5 className="modal-title" id="exampleModalLabel">
//                 Add User
//               </h5>
//             </Modal.Header>
//             <Form className="tablelist-form">
//               <Modal.Body className="p-4">
//                 <div
//                   id="alert-error-msg"
//                   className="d-none alert alert-danger py-2"
//                 ></div>
//                 <input type="hidden" id="id-field" />

//                 <div className="text-center">
//                   <div className="position-relative d-inline-block">
//                     <div className="position-absolute  bottom-0 end-0">
//                       <label
//                         htmlFor="customer-image-input"
//                         className="mb-0"
//                         data-bs-toggle="tooltip"
//                         data-bs-placement="right"
//                         title="Select Image"
//                       >
//                         <div className="avatar-xs cursor-pointer">
//                           <div className="avatar-title bg-light border rounded-circle text-muted">
//                             <i className="ri-image-fill"></i>
//                           </div>
//                         </div>
//                       </label>
//                       <Form.Control
//                         className="d-none"
//                         defaultValue=""
//                         id="users-image-input"
//                         type="file"
//                         accept="image/png, image/gif, image/jpeg"
//                       />
//                     </div>
//                     <div className="avatar-lg p-1">
//                       <div className="avatar-title bg-light rounded-circle">
//                         <img
//                           src={dummyImg}
//                           alt="dummyImg"
//                           id="users-img-field"
//                           className="avatar-md rounded-circle object-cover"
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="mb-3">
//                   <Form.Label htmlFor="user-name">User Name</Form.Label>
//                   <Form.Control
//                     type="text"
//                     id="user-name-field"
//                     placeholder="Enter Name"
//                     required
//                   />
//                 </div>
//                 <div className="mb-3">
//                   <Form.Label htmlFor="email-field">User Email</Form.Label>
//                   <Form.Control
//                     type="email"
//                     id="email-field"
//                     placeholder="Enter Email"
//                     required
//                   />
//                 </div>

//                 <div className="mb-3">
//                   <Form.Label htmlFor="date-field">Date</Form.Label>
//                   <Flatpickr
//                     className="form-control flatpickr-input"
//                     placeholder="Select Date"
//                     options={{
//                       mode: "range",
//                       dateFormat: "d M, Y",
//                     }}
//                   />
//                 </div>

//                 <div>
//                   <label htmlFor="account-status" className="form-label">
//                     Account Status
//                   </label>
//                   <select
//                     className="form-select"
//                     required
//                     id="account-status-field"
//                   >
//                     <option defaultValue="">Account Status</option>
//                     <option value="Active">Active</option>
//                     <option value="Inactive">inactive</option>
//                   </select>
//                 </div>
//               </Modal.Body>
//               <div className="modal-footer">
//                 <div className="hstack gap-2 justify-content-end">
//                   <Button
//                     className="btn-ghost-danger"
//                     onClick={() => {
//                       tog_AddUserModals();
//                     }}
//                   >
//                     Close
//                   </Button>
//                   <Button variant="success" id="add-btn">
//                     Add User
//                   </Button>
//                 </div>
//               </div>
//             </Form>
//           </Modal>
//         </Container>
//       </div>
//     </React.Fragment>
//   );
// };

// export default UsersList;

import React, { useState, useMemo, useCallback, useEffect } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Modal,
  Row,
} from "react-bootstrap";
import Breadcrumb from "Common/BreadCrumb";
import CountUp from "react-countup";
import TableContainer from "Common/TableContainer";
import Flatpickr from "react-flatpickr";
import dummyImg from "../../assets/images/users/user-dummy-img.jpg";
import { Link } from "react-router-dom";
import {
  addUserByAdmin,
  deleteUserById,
  editUserByAdmin,
  fetchUsers,
} from "api/apis";
import { toast } from "react-toastify";

const UsersList = () => {
  document.title = "Users List";
  const [modal_AddUserModals, setmodal_AddUserModals] =
    useState<boolean>(false);

  const [isMultiDeleteButton, setIsMultiDeleteButton] =
    useState<boolean>(false);

  const [usersData, setUsersData] = useState<any[]>([]);

  const [loading, setLoading] = useState<boolean>(true);

  const [modal_EditUserModals, setmodal_EditUserModals] =
    useState<boolean>(false);

  const [selectedUser, setSelectedUser] = useState<any>(null);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [dateFilter, setDateFilter] = useState<string>("all");

  const filterUsersByDate = useCallback((users: any[], filter: string) => {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    const last7Days = new Date(today);
    last7Days.setDate(last7Days.getDate() - 7);

    return users.filter((user) => {
      if (!user.created) return false;

      const userDate = new Date(user.created);
      const userDay = new Date(
        userDate.getFullYear(),
        userDate.getMonth(),
        userDate.getDate(),
      );

      switch (filter) {
        case "all":
          return true;
        case "Today":
          return userDay.getTime() === today.getTime();
        case "Yesterday":
          return userDay.getTime() === yesterday.getTime();
        case "Last 7 Days":
          return userDay >= last7Days && userDay <= today;
        default:
          return true;
      }
    });
  }, []);

  const filteredUsersData = useMemo(() => {
    // First filter by search term
    let filtered = usersData;
    if (searchTerm.trim()) {
      filtered = usersData.filter((user) => {
        const firstName = (user.firstName || user.username || "").toLowerCase();
        const email = (user.email || "").toLowerCase();
        const search = searchTerm.toLowerCase();
        return firstName.includes(search) || email.includes(search);
      });
    }

    // Then filter by date
    return filterUsersByDate(filtered, dateFilter);
  }, [usersData, searchTerm, dateFilter, filterUsersByDate]);

  // Handle search input change
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    status: "Active",
  });

  const handleInputChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value })); // ✅ Correct state
  };

  const handleUpdateUser = async () => {
    if (!selectedUser) return;

    try {
      const updateData = {
        firstName:
          formData.name || selectedUser.firstName || selectedUser.username, // ✅ Changed 'name' to 'firstName'
        email: formData.email || selectedUser.email,
        // Note: Remove status if your API doesn't support it
        // status: formData.status || selectedUser.status || "Active",
      };

      console.log("Sending update data:", updateData); // Debug log
      console.log("User ID:", selectedUser._id); // Debug log

      await editUserByAdmin(selectedUser._id, updateData);

      // Refresh the users list
      await getUsers(pagination.page, pagination.limit);

      // Close the modal
      tog_EditUserModals(null);

      // Optional: Show success message
      console.log("User updated successfully");
      toast.success("User Updated Successfully");
    } catch (error: any) {
      toast.error("Error Updating User:", error);
      // console.error("Error updating user:", error);
      // You might want to show an error message to the user here
    }
  };

  function tog_EditUserModals(user: any) {
    if (user) {
      console.log("Editing user with ID:", user._id);
      setSelectedUser(user);
      setFormData({
        name: user.firstName || user.username || "",
        email: user.email || "",
        status: user.status || "Active",
      });
    }
    setmodal_EditUserModals(!modal_EditUserModals);
  }

  const [addUserModalVisible, setAddUserModalVisible] = useState(false);
  const [addUserFormData, setAddUserFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    role: "ROLE MEMBER",
    provider: "Email",
    merchant: null,
    accountStatus: "",
    createdDate: null as string | null,
  });

  const toggleAddUserModal = () => {
    setAddUserModalVisible(!addUserModalVisible);
  };

  const handleAddUserInputChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    const { id, value } = e.target;
    if (id === "account-status-field") {
      setAddUserFormData((prev) => ({ ...prev, accountStatus: value }));
    } else if (id === "role-field") {
      setAddUserFormData((prev) => ({ ...prev, role: value }));
    } else {
      // Convert IDs like 'firstName-field' to camelCase keys like 'firstName'
      const key = id.replace("-field", "");
      setAddUserFormData((prev) => ({ ...prev, [key]: value }));
    }
  };

  const handleAddUserDateChange = (selectedDates: Date[]) => {
    if (selectedDates.length > 0) {
      setAddUserFormData((prev) => ({
        ...prev,
        createdDate: selectedDates[0].toISOString(),
      }));
    } else {
      setAddUserFormData((prev) => ({ ...prev, createdDate: null }));
    }
  };

  // const handleAddUserSubmit = async (e: React.FormEvent) => {
  //   e.preventDefault();

  //   if (
  //     !addUserFormData.email ||
  //     !addUserFormData.password ||
  //     !addUserFormData.role
  //   ) {
  //     alert("Email, Password and Role are required");
  //     return;
  //   }

  //   try {
  //     const payload = {
  //       email: addUserFormData.email,
  //       firstName: addUserFormData.firstName,
  //       lastName: addUserFormData.lastName,
  //       password: addUserFormData.password,
  //       role: addUserFormData.role,
  //       provider: addUserFormData.provider,
  //       merchant: addUserFormData.merchant,
  //       status: addUserFormData.accountStatus || undefined,
  //       created: addUserFormData.createdDate
  //         ? new Date(addUserFormData.createdDate)
  //         : undefined,
  //     };

  //     await addUserByAdmin(payload);
  //     alert("User added successfully");
  //     toggleAddUserModal();

  //     setAddUserFormData({
  //       firstName: "",
  //       lastName: "",
  //       email: "",
  //       password: "",
  //       role: "ROLE MEMBER",
  //       provider: "Email",
  //       merchant: null,
  //       accountStatus: "",
  //       createdDate: null,
  //     });
  //   } catch (error: any) {
  //     alert("Error adding user: " + (error.message || error));
  //   }
  // };

  const handleAddUserSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (
      !addUserFormData.email ||
      !addUserFormData.password ||
      !addUserFormData.role
    ) {
      alert("Email, Password and Role are required");
      return;
    }

    try {
      const payload = {
        email: addUserFormData.email,
        firstName: addUserFormData.firstName,
        lastName: addUserFormData.lastName,
        password: addUserFormData.password,
        role: addUserFormData.role,
        provider: addUserFormData.provider,
        merchant: addUserFormData.merchant,
        status: addUserFormData.accountStatus || undefined,
        created: addUserFormData.createdDate
          ? new Date(addUserFormData.createdDate)
          : undefined,
      };

      await addUserByAdmin(payload);
      // alert("User added successfully");
      toast.success("User added successfully");

      // Close the modal
      toggleAddUserModal();

      // Reset form data
      setAddUserFormData({
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        role: "ROLE MEMBER",
        provider: "Email",
        merchant: null,
        accountStatus: "",
        createdDate: null,
      });

      // ✅ REFRESH THE USERS LIST - This was missing!
      await getUsers(pagination.page, pagination.limit);
    } catch (error: any) {
      console.log(error);
      // alert("Error adding user: " + (error.message || error));
      toast.error("Error adding user: " + error?.response?.data?.message);
    }
  };

  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    totalPages: 0,
    count: 0,
  });

  const getUsers = useCallback(async (page: number, limit: number) => {
    try {
      setLoading(true);
      const response = await fetchUsers(page, limit);
      setUsersData(response?.users || []);
      console.log("Users: ", response?.users);
      setPagination({
        page: response.currentPage,
        limit: limit,
        totalPages: response.totalPages,
        count: response.count,
      });
    } catch (error: any) {
      toast.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  // Load initial data
  useEffect(() => {
    getUsers(pagination.page, pagination.limit);
  }, []);

  // Handle page change
  const handlePageChange = (page: number) => {
    const apiPage = page + 1; // Convert from zero-based to one-based
    console.log("Page change:", { uiPage: page, apiPage }); // Debug log

    setPagination((prev) => ({ ...prev, page: apiPage }));
    getUsers(apiPage, pagination.limit); // Immediately fetch new data
  };

  // Handle page size change
  const handlePageSizeChange = (limit: number) => {
    console.log("Page size change:", limit); // Debug log

    setPagination((prev) => ({ ...prev, limit, page: 1 }));
    getUsers(1, limit); // Reset to page 1 and fetch new data
  };

  function tog_AddUserModals() {
    setmodal_AddUserModals(!modal_AddUserModals);
  }

  // Checked All
  const checkedAll = useCallback(() => {
    const checkall = document.getElementById("checkAll") as HTMLInputElement;
    const ele = document.querySelectorAll(".userCheckBox");

    if (checkall.checked) {
      ele.forEach((ele: any) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele: any) => {
        ele.checked = false;
      });
    }
    checkedbox();
  }, []);

  const checkedbox = () => {
    const ele = document.querySelectorAll(".userCheckBox:checked");
    ele.length > 0
      ? setIsMultiDeleteButton(true)
      : setIsMultiDeleteButton(false);
  };

  // const columns = useMemo(
  //   () => [
  //     {
  //       Header: (
  //         <div className="form-check">
  //           <input
  //             className="form-check-input"
  //             type="checkbox"
  //             id="checkAll"
  //             onClick={() => checkedAll()}
  //           />
  //         </div>
  //       ),
  //       Cell: (cellProps: any) => {
  //         return (
  //           <div className="form-check">
  //             <input
  //               className="userCheckBox form-check-input"
  //               type="checkbox"
  //               name="chk_child"
  //               value={cellProps.row.original.email} // Use email since _id is excluded
  //               onChange={() => checkedbox()}
  //             />
  //           </div>
  //         );
  //       },
  //       id: "#",
  //     },
  //     {
  //       Header: "User Name",
  //       disableFilters: true,
  //       filterable: true,
  //       accessor: (cellProps: any) => {
  //         return (
  //           <div className="d-flex align-items-center gap-2">
  //             <div className="flex-shrink-0">
  //               <img
  //                 src={cellProps.user_img || dummyImg} // Use dummyImg as fallback
  //                 alt=""
  //                 className="avatar-xs rounded-circle user-profile-img"
  //               />
  //             </div>
  //             <div className="flex-grow-1 ms-2 user_name">
  //               {cellProps.firstName || cellProps.username || "N/A"}{" "}
  //               {/* Handle different name fields */}
  //             </div>
  //           </div>
  //         );
  //       },
  //     },
  //     {
  //       Header: "Email",
  //       accessor: "email",
  //       disableFilters: true,
  //       filterable: true,
  //     },
  //     {
  //       Header: "Create Date",
  //       accessor: "created", // Use 'created' from your API response
  //       disableFilters: true,
  //       filterable: true,
  //       Cell: (cellProps: any) => {
  //         return new Date(cellProps.value).toLocaleDateString(); // Format date
  //       },
  //     },
  //     {
  //       Header: "Account Status",
  //       disableFilters: true,
  //       filterable: true,
  //       accessor: (cellProps: any) => {
  //         // Since your API doesn't return status, we'll assume Active for all
  //         const status = cellProps.status || "Active";
  //         switch (status) {
  //           case "Active":
  //             return (
  //               <span className="badge bg-success-subtle text-success">
  //                 {status}
  //               </span>
  //             );
  //           case "Inactive":
  //             return (
  //               <span className="badge bg-danger-subtle text-danger">
  //                 {status}
  //               </span>
  //             );
  //           default:
  //             return (
  //               <span className="badge bg-success-subtle text-success">
  //                 Active
  //               </span>
  //             );
  //         }
  //       },
  //     },
  //     // {
  //     //   Header: "Action",
  //     //   accessor: "action", // this can be any dummy string since you're rendering custom JSX
  //     //   disableFilters: true,
  //     //   Cell: ({ row }: any) => {
  //     //     return (
  //     //       <div className="d-flex gap-2">
  //     //         <div className="edit">
  //     //           <Button
  //     //             variant="ghost-info"
  //     //             size="sm"
  //     //             className="btn-ghost-info btn-icon edit-item-btn"
  //     //             onClick={() => tog_EditUserModals(row.original)}
  //     //           >
  //     //             <i className="ph-pencil-line"></i>
  //     //           </Button>
  //     //         </div>
  //     //         <div className="remove">
  //     //           <Button
  //     //             variant="ghost-danger"
  //     //             size="sm"
  //     //             className="btn-ghost-danger btn-icon remove-item-btn"
  //     //           >
  //     //             <i className="ph-trash"></i>
  //     //           </Button>
  //     //         </div>
  //     //       </div>
  //     //     );
  //     //   },
  //     // },
  //     // The main issue is in your Action column Cell component
  //     // You're using row.original.id but your API likely expects _id

  //     {
  //       Header: "Action",
  //       accessor: "action",
  //       disableFilters: true,
  //       Cell: ({ row }: any) => {
  //         const handleDelete = async (userId: string) => {
  //           const confirmDelete = window.confirm(
  //             "Are you sure you want to delete this user?"
  //           );
  //           if (!confirmDelete) return;

  //           try {
  //             console.log("Attempting to delete user with ID:", userId); // Debug log
  //             await deleteUserById(userId);
  //             alert("User deleted successfully");

  //             // Refresh the user list after successful deletion
  //             await getUsers(pagination.page, pagination.limit);
  //           } catch (error: any) {
  //             console.error("Delete error:", error); // Better error logging
  //             const errorMessage =
  //               error.response?.data?.message ||
  //               error.message ||
  //               "Failed to delete user";
  //             alert(errorMessage);
  //           }
  //         };

  //         return (
  //           <div className="d-flex gap-2">
  //             <div className="edit">
  //               <Button
  //                 variant="ghost-info"
  //                 size="sm"
  //                 className="btn-ghost-info btn-icon edit-item-btn"
  //                 onClick={() => tog_EditUserModals(row.original)}
  //               >
  //                 <i className="ph-pencil-line"></i>
  //               </Button>
  //             </div>
  //             <div className="remove">
  //               <Button
  //                 variant="ghost-danger"
  //                 size="sm"
  //                 className="btn-ghost-danger btn-icon remove-item-btn"
  //                 // FIXED: Use _id instead of id
  //                 onClick={() => handleDelete(row.original._id)}
  //               >
  //                 <i className="ph-trash"></i>
  //               </Button>
  //             </div>
  //           </div>
  //         );
  //       },
  //     },
  //     // {
  //     //   Header: "Action",
  //     //   accessor: "action", // dummy accessor
  //     //   disableFilters: true,
  //     //   Cell: ({ row }: any) => {
  //     //     const handleDelete = async (id: string) => {
  //     //       const confirmDelete = window.confirm(
  //     //         "Are you sure you want to delete this user?"
  //     //       );
  //     //       if (!confirmDelete) return;

  //     //       try {
  //     //         await deleteUserById(id);
  //     //         alert("User deleted successfully");
  //     //         // Optionally refresh the user list after deletion
  //     //         // Example: refetchUsers(); or trigger any state reload
  //     //       } catch (error: any) {
  //     //         alert(error.message || "Failed to delete user");
  //     //       }
  //     //     };

  //     //     return (
  //     //       <div className="d-flex gap-2">
  //     //         <div className="edit">
  //     //           <Button
  //     //             variant="ghost-info"
  //     //             size="sm"
  //     //             className="btn-ghost-info btn-icon edit-item-btn"
  //     //             onClick={() => tog_EditUserModals(row.original)}
  //     //           >
  //     //             <i className="ph-pencil-line"></i>
  //     //           </Button>
  //     //         </div>
  //     //         <div className="remove">
  //     //           <Button
  //     //             variant="ghost-danger"
  //     //             size="sm"
  //     //             className="btn-ghost-danger btn-icon remove-item-btn"
  //     //             onClick={() => handleDelete(row.original.id)}
  //     //           >
  //     //             <i className="ph-trash"></i>
  //     //           </Button>
  //     //         </div>
  //     //       </div>
  //     //     );
  //     //   },
  //     // },
  //   ],
  //   [checkedAll]
  // );

  const columns = useMemo(
    () => [
      {
        Header: "User Name",
        accessor: (row: any) => row.firstName || row.username || "", // Proper accessor for filtering
        disableFilters: false,
        filterable: true,
        Cell: (cellProps: any) => {
          return (
            <div className="d-flex align-items-center gap-2">
              <div className="flex-shrink-0">
                <img
                  src={cellProps.row.original.user_img || dummyImg}
                  alt=""
                  className="avatar-xs rounded-circle user-profile-img"
                />
              </div>
              <div className="flex-grow-1 ms-2 user_name">
                {cellProps.row.original.firstName ||
                  cellProps.row.original.username ||
                  "N/A"}
              </div>
            </div>
          );
        },
      },
      {
        Header: "Email",
        accessor: "email", // Direct accessor to email field
        disableFilters: false,
        filterable: true,
      },
      {
        Header: "Create Date",
        accessor: "created",
        disableFilters: true, // Disable filtering for dates unless you implement date filtering
        Cell: (cellProps: any) => {
          return new Date(cellProps.value).toLocaleDateString();
        },
      },
      {
        Header: "Account Status",
        accessor: "status",
        disableFilters: false,
        filterable: true,
        Cell: (cellProps: any) => {
          const status = cellProps.value || "Active";
          switch (status) {
            case "Active":
              return (
                <span className="badge bg-success-subtle text-success">
                  {status}
                </span>
              );
            case "Inactive":
              return (
                <span className="badge bg-danger-subtle text-danger">
                  {status}
                </span>
              );
            default:
              return (
                <span className="badge bg-success-subtle text-success">
                  Active
                </span>
              );
          }
        },
      },
      {
        Header: "Action",
        accessor: "action",
        disableFilters: true,
        Cell: ({ row }: any) => {
          const handleDelete = async (userId: string) => {
            const confirmDelete = window.confirm(
              "Are you sure you want to delete this user?",
            );
            if (!confirmDelete) return;

            try {
              await deleteUserById(userId);
              toast.success("User deleted successfully");
              await getUsers(pagination.page, pagination.limit);
            } catch (error: any) {
              const errorMessage =
                error.response?.data?.message ||
                error.message ||
                "Failed to delete user";
              toast.error(errorMessage);
            }
          };

          return (
            <div className="d-flex gap-2">
              <div className="edit">
                <Button
                  variant="ghost-info"
                  size="sm"
                  className="btn-ghost-info btn-icon edit-item-btn"
                  onClick={() => tog_EditUserModals(row.original)}
                >
                  <i className="ph-pencil-line"></i>
                </Button>
              </div>
              <div className="remove">
                <Button
                  variant="ghost-danger"
                  size="sm"
                  className="btn-ghost-danger btn-icon remove-item-btn"
                  onClick={() => handleDelete(row.original._id)}
                >
                  <i className="ph-trash"></i>
                </Button>
              </div>
            </div>
          );
        },
      },
    ],
    [checkedAll],
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb title="Users List" pageTitle="More" />

          <Row>
            <Col xxl={4} md={6}>
              <Card className="card-height-100 bg-warning-subtle border-0 overflow-hidden">
                <div className="position-absolute end-0 start-0 top-0 z-0">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.1"
                    width="400"
                    height="250"
                    preserveAspectRatio="none"
                    viewBox="0 0 400 250"
                  >
                    <g mask='url("#SvgjsMask1530")' fill="none">
                      <path
                        d="M209 112L130 191"
                        strokeWidth="10"
                        stroke="url(#SvgjsLinearGradient1531)"
                        strokeLinecap="round"
                        className="BottomLeft"
                      ></path>
                      <path
                        d="M324 10L149 185"
                        strokeWidth="8"
                        stroke="url(#SvgjsLinearGradient1532)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M333 35L508 -140"
                        strokeWidth="10"
                        stroke="url(#SvgjsLinearGradient1532)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M282 58L131 209"
                        strokeWidth="10"
                        stroke="url(#SvgjsLinearGradient1531)"
                        strokeLinecap="round"
                        className="BottomLeft"
                      ></path>
                      <path
                        d="M290 16L410 -104"
                        strokeWidth="6"
                        stroke="url(#SvgjsLinearGradient1532)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M216 186L328 74"
                        strokeWidth="6"
                        stroke="url(#SvgjsLinearGradient1531)"
                        strokeLinecap="round"
                        className="BottomLeft"
                      ></path>
                      <path
                        d="M255 53L176 132"
                        strokeWidth="10"
                        stroke="url(#SvgjsLinearGradient1531)"
                        strokeLinecap="round"
                        className="BottomLeft"
                      ></path>
                      <path
                        d="M339 191L519 11"
                        strokeWidth="8"
                        stroke="url(#SvgjsLinearGradient1531)"
                        strokeLinecap="round"
                        className="BottomLeft"
                      ></path>
                      <path
                        d="M95 151L185 61"
                        strokeWidth="6"
                        stroke="url(#SvgjsLinearGradient1532)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M249 16L342 -77"
                        strokeWidth="6"
                        stroke="url(#SvgjsLinearGradient1532)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M129 230L286 73"
                        strokeWidth="10"
                        stroke="url(#SvgjsLinearGradient1531)"
                        strokeLinecap="round"
                        className="BottomLeft"
                      ></path>
                      <path
                        d="M80 216L3 293"
                        strokeWidth="6"
                        stroke="url(#SvgjsLinearGradient1531)"
                        strokeLinecap="round"
                        className="BottomLeft"
                      ></path>
                    </g>
                    <defs>
                      <mask id="SvgjsMask1530">
                        <rect width="400" height="250" fill="#ffffff"></rect>
                      </mask>
                      <linearGradient
                        x1="100%"
                        y1="0%"
                        x2="0%"
                        y2="100%"
                        id="SvgjsLinearGradient1531"
                      >
                        <stop
                          stopColor="rgba(var(--tb-warning-rgb), 0)"
                          offset="0"
                        ></stop>
                        <stop
                          stopColor="rgba(var(--tb-warning-rgb), 0.2)"
                          offset="1"
                        ></stop>
                      </linearGradient>
                      <linearGradient
                        x1="0%"
                        y1="100%"
                        x2="100%"
                        y2="0%"
                        id="SvgjsLinearGradient1532"
                      >
                        <stop
                          stopColor="rgba(var(--tb-warning-rgb), 0)"
                          offset="0"
                        ></stop>
                        <stop
                          stopColor="rgba(var(--tb-warning-rgb), 0.2)"
                          offset="1"
                        ></stop>
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <Card.Body className="p-4 z-1 position-relative">
                  <h4 className="fs-22 fw-semibold mb-3">
                    <CountUp end={pagination.count || 0} separator="," />
                  </h4>
                  <p className="mb-0 fw-medium text-uppercase fs-14">
                    Total Users
                  </p>
                </Card.Body>
              </Card>
            </Col>
            <Col xxl={4} md={6}>
              <Card className="card-height-100 bg-success-subtle border-0 overflow-hidden">
                <div className="position-absolute end-0 start-0 top-0 z-0">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.1"
                    width="400"
                    height="250"
                    preserveAspectRatio="none"
                    viewBox="0 0 400 250"
                  >
                    <g mask='url("#SvgjsMask1608")' fill="none">
                      <path
                        d="M390 87L269 208"
                        strokeWidth="10"
                        stroke="url(#SvgjsLinearGradient1609)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M358 175L273 260"
                        strokeWidth="8"
                        stroke="url(#SvgjsLinearGradient1610)"
                        strokeLinecap="round"
                        className="BottomLeft"
                      ></path>
                      <path
                        d="M319 84L189 214"
                        strokeWidth="10"
                        stroke="url(#SvgjsLinearGradient1609)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M327 218L216 329"
                        strokeWidth="8"
                        stroke="url(#SvgjsLinearGradient1610)"
                        strokeLinecap="round"
                        className="BottomLeft"
                      ></path>
                      <path
                        d="M126 188L8 306"
                        strokeWidth="8"
                        stroke="url(#SvgjsLinearGradient1610)"
                        strokeLinecap="round"
                        className="BottomLeft"
                      ></path>
                      <path
                        d="M220 241L155 306"
                        strokeWidth="10"
                        stroke="url(#SvgjsLinearGradient1610)"
                        strokeLinecap="round"
                        className="BottomLeft"
                      ></path>
                      <path
                        d="M361 92L427 26"
                        strokeWidth="6"
                        stroke="url(#SvgjsLinearGradient1609)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M391 188L275 304"
                        strokeWidth="8"
                        stroke="url(#SvgjsLinearGradient1609)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M178 74L248 4"
                        strokeWidth="10"
                        stroke="url(#SvgjsLinearGradient1610)"
                        strokeLinecap="round"
                        className="BottomLeft"
                      ></path>
                      <path
                        d="M84 52L-56 192"
                        strokeWidth="6"
                        stroke="url(#SvgjsLinearGradient1610)"
                        strokeLinecap="round"
                        className="BottomLeft"
                      ></path>
                      <path
                        d="M183 111L247 47"
                        strokeWidth="10"
                        stroke="url(#SvgjsLinearGradient1610)"
                        strokeLinecap="round"
                        className="BottomLeft"
                      ></path>
                      <path
                        d="M46 8L209 -155"
                        strokeWidth="6"
                        stroke="url(#SvgjsLinearGradient1609)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                    </g>
                    <defs>
                      <mask id="SvgjsMask1608">
                        <rect width="400" height="250" fill="#ffffff"></rect>
                      </mask>
                      <linearGradient
                        x1="0%"
                        y1="100%"
                        x2="100%"
                        y2="0%"
                        id="SvgjsLinearGradient1609"
                      >
                        <stop
                          stopColor="rgba(var(--tb-success-rgb), 0)"
                          offset="0"
                        ></stop>
                        <stop
                          stopColor="rgba(var(--tb-success-rgb), 0.2)"
                          offset="1"
                        ></stop>
                      </linearGradient>
                      <linearGradient
                        x1="100%"
                        y1="0%"
                        x2="0%"
                        y2="100%"
                        id="SvgjsLinearGradient1610"
                      >
                        <stop
                          stopColor="rgba(var(--tb-success-rgb), 0)"
                          offset="0"
                        ></stop>
                        <stop
                          stopColor="rgba(var(--tb-success-rgb), 0.2)"
                          offset="1"
                        ></stop>
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <Card.Body className="p-4 z-1 position-relative">
                  <h4 className="fs-22 fw-semibold mb-3">
                    <CountUp end={pagination.count || 0} decimals={0} />
                  </h4>
                  <p className="mb-0 fw-medium text-uppercase fs-14">
                    Active Users
                  </p>
                </Card.Body>
              </Card>
            </Col>
            <Col xxl={4} md={6}>
              <Card className="card-height-100 bg-info-subtle border-0 overflow-hidden">
                <div className="position-absolute end-0 start-0 top-0 z-0">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.1"
                    width="400"
                    height="250"
                    preserveAspectRatio="none"
                    viewBox="0 0 400 250"
                  >
                    <g mask='url("#SvgjsMask1551")' fill="none">
                      <path
                        d="M306 65L446 -75"
                        strokeWidth="8"
                        stroke="url(#SvgjsLinearGradient1552)"
                        strokeLinecap="round"
                        className="BottomLeft"
                      ></path>
                      <path
                        d="M399 2L315 86"
                        strokeWidth="10"
                        stroke="url(#SvgjsLinearGradient1553)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M83 77L256 -96"
                        strokeWidth="6"
                        stroke="url(#SvgjsLinearGradient1553)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M281 212L460 33"
                        strokeWidth="6"
                        stroke="url(#SvgjsLinearGradient1553)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M257 62L76 243"
                        strokeWidth="6"
                        stroke="url(#SvgjsLinearGradient1553)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M305 123L214 214"
                        strokeWidth="6"
                        stroke="url(#SvgjsLinearGradient1552)"
                        strokeLinecap="round"
                        className="BottomLeft"
                      ></path>
                      <path
                        d="M327 222L440 109"
                        strokeWidth="6"
                        stroke="url(#SvgjsLinearGradient1552)"
                        strokeLinecap="round"
                        className="BottomLeft"
                      ></path>
                      <path
                        d="M287 109L362 34"
                        strokeWidth="10"
                        stroke="url(#SvgjsLinearGradient1553)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M259 194L332 121"
                        strokeWidth="8"
                        stroke="url(#SvgjsLinearGradient1553)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M376 186L240 322"
                        strokeWidth="8"
                        stroke="url(#SvgjsLinearGradient1553)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M308 153L123 338"
                        strokeWidth="6"
                        stroke="url(#SvgjsLinearGradient1553)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M218 62L285 -5"
                        strokeWidth="8"
                        stroke="url(#SvgjsLinearGradient1552)"
                        strokeLinecap="round"
                        className="BottomLeft"
                      ></path>
                    </g>
                    <defs>
                      <mask id="SvgjsMask1551">
                        <rect width="400" height="250" fill="#ffffff"></rect>
                      </mask>
                      <linearGradient
                        x1="100%"
                        y1="0%"
                        x2="0%"
                        y2="100%"
                        id="SvgjsLinearGradient1552"
                      >
                        <stop
                          stopColor="rgba(var(--tb-info-rgb), 0)"
                          offset="0"
                        ></stop>
                        <stop
                          stopColor="rgba(var(--tb-info-rgb), 0.2)"
                          offset="1"
                        ></stop>
                      </linearGradient>
                      <linearGradient
                        x1="0%"
                        y1="100%"
                        x2="100%"
                        y2="0%"
                        id="SvgjsLinearGradient1553"
                      >
                        <stop
                          stopColor="rgba(var(--tb-info-rgb), 0)"
                          offset="0"
                        ></stop>
                        <stop
                          stopColor="rgba(var(--tb-info-rgb), 0.2)"
                          offset="1"
                        ></stop>
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <Card.Body className="p-4 z-1 position-relative">
                  <h4 className="fs-22 fw-semibold mb-3">
                    <CountUp end={0} decimals={0} />
                  </h4>
                  <p className="mb-0 fw-medium text-uppercase fs-14">
                    Inactive Users
                  </p>
                </Card.Body>
              </Card>
            </Col>
            {/* <Col xxl={3} md={6}>
              <Card className="bg-light border-0">
                <Card.Body className="p-3">
                  <div className="p-3 bg-white rounded">
                    <div className="d-flex align-items-center gap-3">
                      <div className="flex-shrink-0">
                        <div className="avatar-sm">
                          <div className="avatar-title bg-danger-subtle text-danger fs-4 rounded">
                            <i className="ph-gift"></i>
                          </div>
                        </div>
                      </div>
                      <div className="flex-grow-1">
                        <Link to="#" className="stretched-link">
                          <h6 className="fs-17">
                            Invite your friends to Anjalgold
                          </h6>
                        </Link>
                        <p className="text-muted mb-0">
                          Nor again is there anyone pursues
                        </p>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col> */}
          </Row>

          <Row id="usersList">
            <Col lg={12}>
              <Card>
                <Card.Body>
                  <Row className="g-lg-2 g-4">
                    <Col lg={3}>
                      <div className="search-box">
                        <input
                          type="text"
                          className="form-control search"
                          placeholder="Search for users..."
                          value={searchTerm}
                          onChange={handleSearchChange}
                        />
                        <i className="ri-search-line search-icon"></i>
                      </div>
                    </Col>
                    {isMultiDeleteButton && (
                      <Button variant="danger" className="btn-icon">
                        <i className="ri-delete-bin-2-line"></i>
                      </Button>
                    )}

                    <Col sm={3} className="col-lg-auto ms-auto">
                      <Button
                        onClick={toggleAddUserModal}
                        variant="primary"
                        type="button"
                        className="w-100 add-btn"
                      >
                        Add User
                      </Button>
                    </Col>
                    <Col sm={9} className="col-lg-auto">
                      <select
                        className="form-select"
                        data-choices
                        data-choices-search-false
                        name="choices-single-default"
                        id="idStatus"
                        value={dateFilter}
                        onChange={(e) => setDateFilter(e.target.value)}
                      >
                        <option value="all">All</option>
                        <option value="Today">Today</option>
                        <option value="Yesterday">Yesterday</option>
                        <option value="Last 7 Days">Last 7 Days</option>
                        <option value="Last 30 Days">Last 30 Days</option>
                        <option value="This Month">This Month</option>
                        <option value="Last Month">Last Month</option>
                      </select>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>

              <Card>
                <Card.Body className="p-0">
                  {loading ? (
                    <div className="text-center p-5">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <>
                      <TableContainer
                        columns={columns}
                        data={filteredUsersData} // Changed from usersData to filteredUsersData
                        iscustomPageSize={true}
                        customPageSize={pagination.limit}
                        isFilterable={true}
                        SearchPlaceholder="Search Users..."
                        manualPagination={true}
                        pageCount={pagination.totalPages}
                        currentPage={pagination.page - 1}
                        onPageChange={handlePageChange}
                        onPageSizeChange={handlePageSizeChange}
                      />
                      {filteredUsersData.length === 0 && (
                        <div className="noresult">
                          <div className="text-center p-4">
                            <h5 className="mt-2">
                              {searchTerm
                                ? "No Matching Users Found"
                                : "No Users Found"}
                            </h5>
                            <p className="text-muted mb-0">
                              {searchTerm
                                ? `No users found matching "${searchTerm}". Try a different search term.`
                                : "There are no users to display at the moment."}
                            </p>
                            {searchTerm && (
                              <Button
                                variant="outline-primary"
                                size="sm"
                                onClick={() => setSearchTerm("")}
                                className="mt-2"
                              >
                                Clear Search
                              </Button>
                            )}
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* <Modal
            className="fade"
            show={modal_AddUserModals}
            onHide={() => {
              tog_AddUserModals();
            }}
            centered
          >
            <Modal.Header className="px-4 pt-4" closeButton>
              <h5 className="modal-title" id="exampleModalLabel">
                Add User
              </h5>
            </Modal.Header>
            <Form className="tablelist-form">
              <Modal.Body className="p-4">
                <div
                  id="alert-error-msg"
                  className="d-none alert alert-danger py-2"
                ></div>
                <input type="hidden" id="id-field" />

                <div className="text-center">
                  <div className="position-relative d-inline-block">
                    <div className="position-absolute  bottom-0 end-0">
                      <label
                        htmlFor="customer-image-input"
                        className="mb-0"
                        data-bs-toggle="tooltip"
                        data-bs-placement="right"
                        title="Select Image"
                      >
                        <div className="avatar-xs cursor-pointer">
                          <div className="avatar-title bg-light border rounded-circle text-muted">
                            <i className="ri-image-fill"></i>
                          </div>
                        </div>
                      </label>
                      <Form.Control
                        className="d-none"
                        defaultValue=""
                        id="users-image-input"
                        type="file"
                        accept="image/png, image/gif, image/jpeg"
                      />
                    </div>
                    <div className="avatar-lg p-1">
                      <div className="avatar-title bg-light rounded-circle">
                        <img
                          src={dummyImg}
                          alt="dummyImg"
                          id="users-img-field"
                          className="avatar-md rounded-circle object-cover"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mb-3">
                  <Form.Label htmlFor="user-name">User Name</Form.Label>
                  <Form.Control
                    type="text"
                    id="user-name-field"
                    placeholder="Enter Name"
                    required
                  />
                </div>
                <div className="mb-3">
                  <Form.Label htmlFor="email-field">User Email</Form.Label>
                  <Form.Control
                    type="email"
                    id="email-field"
                    placeholder="Enter Email"
                    required
                  />
                </div>

                <div className="mb-3">
                  <Form.Label htmlFor="date-field">Date</Form.Label>
                  <Flatpickr
                    className="form-control flatpickr-input"
                    placeholder="Select Date"
                    options={{
                      mode: "range",
                      dateFormat: "d M, Y",
                    }}
                  />
                </div>

                <div>
                  <label htmlFor="account-status" className="form-label">
                    Account Status
                  </label>
                  <select
                    className="form-select"
                    required
                    id="account-status-field"
                  >
                    <option defaultValue="">Account Status</option>
                    <option value="Active">Active</option>
                    <option value="Inactive">inactive</option>
                  </select>
                </div>
              </Modal.Body>
              <div className="modal-footer">
                <div className="hstack gap-2 justify-content-end">
                  <Button
                    className="btn-ghost-danger"
                    onClick={() => {
                      tog_AddUserModals();
                    }}
                  >
                    Close
                  </Button>
                  <Button variant="success" id="add-btn">
                    Add User
                  </Button>
                </div>
              </div>
            </Form>
          </Modal> */}
          <Modal
            className="fade"
            show={addUserModalVisible}
            onHide={toggleAddUserModal}
            centered
          >
            <Modal.Header className="px-4 pt-4" closeButton>
              <h5 className="modal-title">Add User</h5>
            </Modal.Header>
            <Form className="tablelist-form" onSubmit={handleAddUserSubmit}>
              <Modal.Body className="p-4">
                <div className="text-center mb-3">
                  <img
                    src={dummyImg}
                    alt="User Avatar"
                    className="avatar-md rounded-circle object-cover"
                  />
                </div>

                <div className="mb-3">
                  <Form.Label htmlFor="firstName-field">First Name</Form.Label>
                  <Form.Control
                    type="text"
                    id="firstName-field"
                    placeholder="Enter First Name"
                    value={addUserFormData.firstName}
                    onChange={handleAddUserInputChange}
                  />
                </div>

                <div className="mb-3">
                  <Form.Label htmlFor="lastName-field">Last Name</Form.Label>
                  <Form.Control
                    type="text"
                    id="lastName-field"
                    placeholder="Enter Last Name"
                    value={addUserFormData.lastName}
                    onChange={handleAddUserInputChange}
                  />
                </div>

                <div className="mb-3">
                  <Form.Label htmlFor="email-field">Email</Form.Label>
                  <Form.Control
                    type="email"
                    id="email-field"
                    placeholder="Enter Email"
                    required
                    value={addUserFormData.email}
                    onChange={handleAddUserInputChange}
                  />
                </div>

                <div className="mb-3">
                  <Form.Label htmlFor="password-field">Password</Form.Label>
                  <Form.Control
                    type="password"
                    id="password-field"
                    placeholder="Enter Password"
                    required
                    value={addUserFormData.password}
                    onChange={handleAddUserInputChange}
                  />
                </div>

                <div className="mb-3">
                  <Form.Label htmlFor="account-status-field">
                    Account Status
                  </Form.Label>
                  <select
                    className="form-select"
                    id="account-status-field"
                    value={addUserFormData.accountStatus}
                    onChange={handleAddUserInputChange}
                    required
                  >
                    <option value="">Select Account Status</option>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </select>
                </div>

                <div className="mb-3">
                  <Form.Label htmlFor="role-field">Role</Form.Label>
                  <select
                    className="form-select"
                    id="role-field"
                    value={addUserFormData.role}
                    onChange={handleAddUserInputChange}
                    required
                  >
                    <option value="ROLE MEMBER">ROLE MEMBER</option>
                    <option value="ROLE ADMIN">ROLE ADMIN</option>
                    {/* Add other roles here if needed */}
                  </select>
                </div>

                <div className="mb-3">
                  <Form.Label htmlFor="date-field">Created Date</Form.Label>
                  <Flatpickr
                    className="form-control flatpickr-input"
                    placeholder="Select Date"
                    options={{ dateFormat: "d M, Y" }}
                    value={
                      addUserFormData.createdDate
                        ? new Date(addUserFormData.createdDate)
                        : undefined
                    }
                    onChange={handleAddUserDateChange}
                  />
                </div>
              </Modal.Body>

              <Modal.Footer>
                <Button variant="ghost-danger" onClick={toggleAddUserModal}>
                  Close
                </Button>
                <Button variant="success" type="submit">
                  Add User
                </Button>
              </Modal.Footer>
            </Form>
          </Modal>

          <Modal
            className="fade"
            show={modal_EditUserModals}
            onHide={() => {
              tog_EditUserModals(null);
            }}
            centered
          >
            <Modal.Header className="px-4 pt-4" closeButton>
              <h5 className="modal-title" id="exampleModalLabel">
                Edit User
              </h5>
            </Modal.Header>
            <Form className="tablelist-form">
              <Modal.Body className="p-4">
                <div
                  id="alert-error-msg"
                  className="d-none alert alert-danger py-2"
                ></div>
                <input type="hidden" id="id-field" />

                <div className="text-center">
                  <div className="position-relative d-inline-block">
                    <div className="position-absolute  bottom-0 end-0">
                      <label
                        htmlFor="customer-image-input"
                        className="mb-0"
                        data-bs-toggle="tooltip"
                        data-bs-placement="right"
                        title="Select Image"
                      >
                        <div className="avatar-xs cursor-pointer">
                          <div className="avatar-title bg-light border rounded-circle text-muted">
                            <i className="ri-image-fill"></i>
                          </div>
                        </div>
                      </label>
                      <Form.Control
                        className="d-none"
                        defaultValue=""
                        id="users-image-input"
                        type="file"
                        accept="image/png, image/gif, image/jpeg"
                      />
                    </div>
                    <div className="avatar-lg p-1">
                      <div className="avatar-title bg-light rounded-circle">
                        <img
                          src={selectedUser?.user_img || dummyImg}
                          alt="dummyImg"
                          id="users-img-field"
                          className="avatar-md rounded-circle object-cover"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mb-3">
                  <Form.Label htmlFor="user-name">User Name</Form.Label>
                  <Form.Control
                    type="text"
                    id="user-name-field"
                    name="name"
                    required
                    placeholder="Enter Name"
                    defaultValue={
                      selectedUser?.firstName || selectedUser?.username || ""
                    }
                    onChange={handleInputChange}
                  />
                </div>
                <div className="mb-3">
                  <Form.Label htmlFor="email-field">User Email</Form.Label>
                  <Form.Control
                    type="email"
                    id="email-field"
                    name="email"
                    placeholder="Enter Email"
                    defaultValue={selectedUser?.email || ""}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <Form.Label htmlFor="date-field">Date</Form.Label>
                  <Flatpickr
                    className="form-control flatpickr-input"
                    placeholder="Select Date"
                    defaultValue={selectedUser?.created}
                    options={{
                      mode: "single",
                      dateFormat: "d M, Y",
                    }}
                  />
                </div>

                <div>
                  <label htmlFor="account-status" className="form-label">
                    Account Status
                  </label>
                  <select
                    className="form-select"
                    required
                    id="account-status-field"
                    defaultValue={selectedUser?.status || "Active"}
                  >
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </select>
                </div>
              </Modal.Body>
              <div className="modal-footer">
                <div className="hstack gap-2 justify-content-end">
                  <Button
                    className="btn-ghost-danger"
                    onClick={() => {
                      tog_EditUserModals(null);
                    }}
                  >
                    Close
                  </Button>
                  <Button
                    variant="success"
                    id="edit-btn"
                    onClick={handleUpdateUser}
                  >
                    Update User
                  </Button>
                </div>
              </div>
            </Form>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default UsersList;
